import { useMemo } from "react";
import { Column, useTable } from "react-table";
import { DefinitionList, DefinitionListItem } from "@funcional/react-ui";
import { IAuthenticationExternalApiData } from "../contracts";
import { keys } from "@material-ui/core/styles/createBreakpoints";
import { ReactTable } from "@funcional/react-table-ui";

export function AuthenticationExternalApiCard({
  authenticationExternalApi,
}: {
  authenticationExternalApi: IAuthenticationExternalApiData;
}) {
  const columns: Column<IAuthenticationExternalApiData>[] = useMemo(
    () =>
      [
        {
          Header: "header",
          accessor: "header",

          Cell: ({ value }: { value: any[] }) =>
            value?.map((item, index) => (
              <tr key={index}>
                <td>
                  <div>
                    <div>{item.key}</div>
                  </div>
                </td>

                <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                  {item.value}
                </td>
              </tr>
            )) || [],
        },
        {
          Header: "form",
          accessor: "form",

          Cell: ({ value }: { value: any[] }) =>
            value?.map((item, index) => (
              <tr key={index}>
                <td>
                  <div>
                    <div>{item.type}</div>
                  </div>
                </td>

                <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                  {item.key}
                </td>
                <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                  {item.value}
                </td>
              </tr>
            )) || [],
        },
      ] as Column<IAuthenticationExternalApiData>[],
    []
  );

  const tableInstance = useTable({
    columns,
    data: [authenticationExternalApi || []] || [],
  });

  console.log("tableInstance", tableInstance);
  return (
    <>
      <DefinitionList className="mb-8">
        <DefinitionListItem label="URL">
          {authenticationExternalApi?.url}
        </DefinitionListItem>
        <DefinitionListItem label="Method">
          {authenticationExternalApi?.method}
        </DefinitionListItem>
        <DefinitionListItem label="Token">
          {authenticationExternalApi?.token}
        </DefinitionListItem>
      </DefinitionList>

      <ReactTable tableInstance={tableInstance} />
    </>
  );
}
